import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=784c0dde&scoped=true&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"
import style0 from "./Add.vue?vue&type=style&index=0&id=784c0dde&lang=scss&scoped=true&"
import style1 from "./Add.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c0dde",
  null
  
)

export default component.exports